import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import AddContactMainData from './AddContactMainData';
import AddContactSecondData from './AddContactSecondData';
import AddContactThirdData from './AddContactThirdData';
import axios from 'axios';

const styles = theme => ({
  root: {
    width: '90%',
  },
  button: {
    marginRight: theme.spacing.unit,
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
});

function getSteps() {
  return ['Main data', 'Avatar', 'Personal data'];
}

function getStepContent(step) {
  switch (step) {
    case 0:
      return (<AddContactMainData/>);
    case 1:
      return (<AddContactSecondData/>);
    case 2:
      return (<AddContactThirdData/>);
    default:
      return 'Unknown step';
  }
}

class AddContactStepper extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleNext = this.handleNext.bind(this);
  }

  state = {
    formControls: {
        name: {
          value: '',
          placeholder: 'Name'
        },
        surname:{
          value: ''
        },
        phone: {
          value: '',
          placeholder: 'Public name'
        },
        email:{
          value: ''
        },
        address:{
          value: ''
        },
        description: {
          value: ''
        },
        id_number_type: {
          value: 'Contact'
        },
        id_number: {
          value: ''
        }

    },
    activeStep: 0,
    skipped: new Set(),
  };


  isStepOptional = step => step === 1;

  handleNext = () => {
    const { activeStep } = this.state;
    let { skipped } = this.state;
    if (this.isStepSkipped(activeStep)) {
      skipped = new Set(skipped.values());
      skipped.delete(activeStep);
    }
    this.setState({
      activeStep: activeStep + 1,
      skipped,
    });
  };

  handleSubmit(e) {
    e.preventDefault();
    const newPerson = this.state.formControls;
    console.log('submitted');
    this.handleNext();



    const confirm = this.props.confirm;

    var person =  { person: {
                  first_name: newPerson.name.value,
                  phone_number: newPerson.phone.value,
                  full_address: newPerson.address.value
                  }
                };

    console.log({newPerson, confirm, person });
    let url = `${process.env.REACT_APP_API_URL}persons` ;
    axios
      .post(url, person, {headers:{ Authorization: 'Bearer ' + confirm }})
      .then((response) => {
        alert('Person Added!');
        const savedPerson = response.data;
        const { history } = this.props;
        history.push(`/persons/${savedPerson.id}`);
      })
      .catch((error) => {
        console.log(error);
      });
    console.log('submitted');
  };



  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1,
    }));
  };

  handleSkip = () => {
    const { activeStep } = this.state;
    if (!this.isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    this.setState(state => {
      const skipped = new Set(state.skipped.values());
      skipped.add(activeStep);
      return {
        activeStep: state.activeStep + 1,
        skipped,
      };
    });
  };

  handleReset = () => {
    this.setState({
      activeStep: 0,
    });
  };

  isStepSkipped(step) {
    return this.state.skipped.has(step);
  }

  changeHandler = event => {
    const name = event.target.id;
    const value = event.target.value;

    const updatedControls = {
      ...this.state.formControls
    };
    const updatedFormElement = {
      ...updatedControls[name]
    };

    console.log(event.target);

    updatedFormElement.value = value;
    updatedFormElement.touched = true;

    // Validations
    // updatedFormElement.valid = validate(value, updatedFormElement.validationRules);

    updatedControls[name] = updatedFormElement;

    this.setState({
      formControls: updatedControls
    });

  };

  render() {
    const { classes } = this.props;
    const steps = getSteps();
    const { activeStep } = this.state;

    return (
      <div className={classes.root}>
        <Stepper activeStep={activeStep}>
          {steps.map((label, index) => {
            const props = {};
            const labelProps = {};
            if (this.isStepOptional(index)) {
              labelProps.optional = <Typography variant="caption">Optional</Typography>;
            }
            if (this.isStepSkipped(index)) {
              props.completed = false;
            }
            return (
              <Step key={label} {...props}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>

        <form className={classes.form} onSubmit={this.handleSubmit}>

          <div>
            {activeStep === steps.length ? (
              <div>
                <Typography className={classes.instructions}>
                  All steps completed - you&apos;re finished
                </Typography>
                <Button onClick={this.handleReset} className={classes.button}>
                  Reset
                </Button>
              </div>
            ) : (

              <div>
              {
                {
                   0: <AddContactMainData changeHandler={this.changeHandler.bind(this)} propertyData={this.state.formControls} />,
                   1: <AddContactSecondData/>,
                   2: <AddContactThirdData/>,
                   default: 'Unknown step'
                }[activeStep]
              }
                <div>
                  <Button
                    disabled={activeStep === 0}
                    onClick={this.handleBack}
                    className={classes.button}
                  >
                    Back
                  </Button>
                  {this.isStepOptional(activeStep) && (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.handleSkip}
                      className={classes.button}
                    >
                      Skip
                    </Button>
                  )}
                  { activeStep === steps.length - 1 ?
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleSubmit}
                        className={classes.button}
                      >
                        Finish
                      </Button>

                      :

                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleNext}
                        className={classes.button}
                      >
                        Next
                      </Button>
                    }
                </div>
              </div>

            )}
          </div>

        </form>

      </div>
    );
  }
}

AddContactStepper.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(styles)(AddContactStepper);
